import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import GlassCard from '../card/GlassCard';
import { themeColors } from 'helpers/utils';
import { disputeCols } from 'services/glass-management/glassManagement';
import SLAChart from '../SLAChart';
import { useSelector, useDispatch } from 'react-redux';
import { openModal } from 'slices/glassDashboard/glassDataModalSlice';
import dayjs from 'dayjs';

const DisputeSummary = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.glassDisputeSummary);
    const { start, end } = useSelector(s => s.glassSearchFilter);

    if (error)
        toast.error('Something went wrong!', error);

    const allDataClick = useCallback(() => {
        dispatch(openModal({
            modalData: data?.total,
            modalLoading: false,
            modalShow: true,
            modalTitle: 'Dispute Summary',
            tableCols: disputeCols,
        }))
    }, [data]);

    const handleChartClick = useCallback(e => {
        let list = [];
        if (e && e?.name)
            switch (e?.name) {
                case 'Out. Pad.':
                    list = data?.outstandingPadiham;
                    break;
                case 'Out. Emp.':
                    list = data?.outstandingEmplas;
                    break;
                case 'Out. Both':
                    list = data?.outstandingBoth;
                    break;
                case 'Complete':
                    list = data?.complete;
                    break;
                case 'Dispute':
                    list = data?.dispute;
                    break;
                case 'Not Categorised':
                    list = data?.notCategorised;
                    break;
            }

        if (list.length)
            dispatch(openModal({
                modalData: list,
                modalLoading: false,
                modalShow: true,
                modalTitle: e.name,
                tableCols: disputeCols,
            }));
    }, [dispatch, data])

    const getPieOptions = useCallback(() => {
        return {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: 0,
                show: true,
            },
            series: [
                {
                    name: 'Dispute Summary',
                    type: 'pie',
                    avoidLabelOverlap: true,
                    center: ['50%', '60%'],
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: true,
                        formatter: '{c}',
                    },
                    labelLine: {
                        show: true,
                    },
                    data: [
                        {
                            name: 'Complete',
                            value: data?.complete?.length,
                            itemStyle: { color: themeColors.success },
                        },
                        {
                            name: 'Dispute',
                            value: data?.dispute?.length,
                            itemStyle: { color: themeColors.danger },
                        },
                        {
                            name: 'Out. Pad.',
                            value: data?.outstandingPadiham?.length,
                            itemStyle: { color: themeColors.warning },
                        },
                        {
                            name: 'Out. Emp.',
                            value: data?.outstandingEmplas?.length,
                            itemStyle: { color: themeColors.primary },
                        },
                        {
                            name: 'Out. Both',
                            value: data?.outstandingBoth?.length,
                            itemStyle: { color: themeColors.secondary },
                        },
                        {
                            name: 'Not Categorised',
                            value: data?.notCategorised?.length,
                            itemStyle: { color: themeColors.info },
                        }
                    ]
                }
            ]
        }
    }, [data]);

    return (
        <GlassCard
            title={`Dispute Summary <small><a target="blank" href="https://eva.emplas.co.uk/Internal/GlassManagement/PadihamFaultSourceDashboard.aspx?from=${dayjs(start).format('YYYY/MM/DD')}&to=${dayjs(end).format('YYYY/MM/DD')}">View on EVA</a></small>`}
            colour='dark'
            heroValue={{ func: () => allDataClick() }}
        >
            <SLAChart
                loading={loading}
                options={getPieOptions()}
                onClick={handleChartClick}
            />
        </GlassCard>
    )
}

export default memo(DisputeSummary);